export default "__VITE_ASSET__d676a197__"